module.exports = __webpack_public_path__ + "static/media/ic-profile-purple.2b10be8c.svg";